<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>OPCR Summary </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="assessed_by_status == 2 ? true : false"
                      :rules="[() => assessed_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ assessed_by }}
                      <small>Assessed By<br /> </small>
                    </v-stepper-step>
                    <!-- <v-divider></v-divider>
                    <v-stepper-step
                      step="2"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>Final Rating <br /> </small>
                    </v-stepper-step> -->
                  </v-stepper-header>
                </v-stepper>
              </v-col>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>

              <v-spacer></v-spacer>

              <v-col cols="12" class=" pt-2 px-4">
                <v-data-table
                  :expanded.sync="expanded"
                  :headers="headers"
                  :items="dataItem"
                  :items-per-page="10"
                  show-expand
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">Linked IPCR</div>
                      <div v-if="item.linkedIPCR.length > 0">
                        <v-data-table
                          :expanded1.sync="expanded1"
                          :headers="linked_headers"
                          :items="item.linkedIPCR"
                          show-expand
                          hide-default-footer
                        >
                          <template v-slot:[`item.e_total`]="{ item }">
                            {{ item.e_total + " | " + item.e_avg }}
                          </template>
                          <template v-slot:[`item.q_total`]="{ item }">
                            {{ item.q_total + " | " + item.q_avg }}
                          </template>
                          <template v-slot:[`item.t_total`]="{ item }">
                            {{ +item.t_total + " | " + item.t_avg }}
                          </template>
                          <template v-slot:[`item.a_avg`]="{ item }">
                            {{ item.a_avg }}
                          </template>
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-4">
                              <table id="tbl_expanded">
                                <tr>
                                  <th
                                    class="text-caption font-weight-bold"
                                    :colspan="
                                      getMonthListAndTblHeaders(
                                        item.periodFrom,
                                        item.periodTo
                                      ).e_span
                                    "
                                    style="width:33%"
                                  >
                                    Efficiency
                                  </th>
                                  <th
                                    class="text-caption font-weight-bold"
                                    :colspan="
                                      getMonthListAndTblHeaders(
                                        item.periodFrom,
                                        item.periodTo
                                      ).qt_span
                                    "
                                    style="width:33%"
                                  >
                                    Quality
                                  </th>
                                  <th
                                    class="text-caption font-weight-bold"
                                    :colspan="
                                      getMonthListAndTblHeaders(
                                        item.periodFrom,
                                        item.periodTo
                                      ).qt_span
                                    "
                                    style="width:33%"
                                  >
                                    Timeliness
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    v-for="(tmp,
                                    indx) in getMonthListAndTblHeaders(
                                      item.periodFrom,
                                      item.periodTo
                                    ).expandHeaders"
                                    :key="indx"
                                    align="center"
                                    class="text-caption font-weight-bold "
                                  >
                                    {{ tmp }}
                                  </td>
                                </tr>

                                <tbody>
                                  <tr>
                                    <td
                                      v-for="(summary, i) in item.mporSummary"
                                      :key="i"
                                      :colspan="summary.colspan"
                                      align="center"
                                      class="text-caption"
                                    >
                                      {{ summary.value }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </template>
                        </v-data-table>
                      </div>
                      <div
                        v-if="item.linkedIPCR.length == 0"
                        class="text-center"
                      >
                        <div class="text-caption"><i>No linked IPCR</i></div>
                      </div>
                    </td>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      block
                      x-small
                      @click="edit(item)"
                      outlined
                      color="#519043"
                      >Update</v-btn
                    >
                    <!-- <v-btn
                      v-if="tab != 3"
                      x-small
                      class="mt-1"
                      @click="deleteItem(item)"
                      outlined
                      color="red"
                      block
                      >Delete</v-btn
                    > -->
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-if="isSubmitted && assessed_by_status == 2">
              <v-col cols="12">
                <v-divider></v-divider>
                <div class="pa-3">
                  <div class="text-h6">
                    Comments and Recommendations for Development Purposes:
                  </div>
                  <div class="text-justify text-subtitle-1">
                    {{ targetRating.comments }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on">
                  Remarks
                </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header  white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="background-color:white;  height : 300px; overflow-y:auto"
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">
                          No remarks found.
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition>
          <v-spacer></v-spacer>
          <!-- 
          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <v-btn
            v-if="shouldSubmit()"
            color="#519043"
            class="white--text"
            @click="submitTarget()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Submit
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this
              <b>Targets for Approval</b>?<br />
              <!-- Please note that
              <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AddOPCRTargetsDialog :data="opcrData" :action="action" :opcrID="id" />
    <!--  <UpdateSupportFunctionDialog
      :data="ipcrSupData"
      :action="action"
      :ipcrID="id"
    />

    <AddIPCRSupportUtilDialog
      :moduleFrom="'Employee'"
      :data="ipcrSupport"
      :action="action"
      :ipcrID="id"
    /> -->

    <!-- <MPORDialog :data="mporData" :action="action" /> -->
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    AddOPCRTargetsDialog: () => import("../OPCR/AddOPCRTargetsDialog.vue"),
    // UpdateSupportFunctionDialog: () =>
    //   import("../Forms/UpdateSupportFunctionDialog.vue"),
    // AddIPCRSupportUtilDialog: () =>
    //   import("../Forms/AddIPCRSupportUtilDialog.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      dialog: false,
      opcrData: null,
      ipcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      expanded1: [],
      isButtonLoading: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
      ],
      headers: [
        {
          text: "MFO",
          value: "mfo",
          width: 400,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          // width: 300,
          valign: "center",
          sortable: false,
        },
      ],
      linked_headers: [
        {
          text: "Employee",
          value: "name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "E",
          value: "e_total",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q",
          value: "q_total",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T",
          value: "t_total",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "A",
          value: "a_avg",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
      ],
      e_span: null,
      qt_span: null,
      expandHeaders: [],
      monthsList: [],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.isSubmitted = data.isSubmitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        this.assessed_by_status = data.assesed_by_status;
        this.id = data.id;

        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    // this.eventHub.$on("closeAddOPCRTargetsDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closePerformanceEvaluationDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeMPORDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeUpdateSupportFunctionDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeAddIPCRSupportUtilDialog", () => {
    //   this.initialize();
    // });
  },

  beforeDestroy() {
    // this.eventHub.$off("closeAddOPCRTargetsDialog");
    // this.eventHub.$off("closeAddIPCRSupportUtilDialog");
    // this.eventHub.$off("closePerformanceEvaluationDialog");
    // this.eventHub.$off("closeMPORDialog");
    // this.eventHub.$off("closeUpdateSupportFunctionDialog");
  },

  methods: {
    initialize() {
      this.loading = true;
      this.dataItem = [];
      this.expanded = [];
      this.expanded1 = [];
      this.loadRemarks(this.id);

      this.axiosCall(
        "/opcr-target/getMyOPCRTargetSummary/" + this.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log(res.data);
          this.dataItem = res.data;
          this.loading = false;
        }
      });
    },

    getMonthListAndTblHeaders(from, to) {
      let d = this.loadMonthList(from, to);
      let d1 = this.loadExpandHeaders(d);
      return {
        monthsList: d,
        expandHeaders: d1,
        e_span: d.length + 1,
        qt_span: d.length + 2,
      };
    },

    loadMonthList(from, to) {
      let mnth = [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ];
      let monthsList = [];

      for (let i = from - 1; i < to; i++) {
        monthsList.push(mnth[i]);
      }
      return monthsList;
    },

    loadExpandHeaders(monthsList) {
      let expandHeaders = [];

      for (let i = 0; i < 3; i++) {
        // this.e_span = this.monthsList.length + 1;
        // this.qt_span = this.monthsList.length + 2;
        for (let j = 0; j < monthsList.length; j++) {
          expandHeaders.push(monthsList[j].name);
        }
        if (i == 0) {
          expandHeaders.push("Total");
        } else if (i > 0) {
          expandHeaders.push("Total");
          expandHeaders.push("AVE");
        }
      }
      return expandHeaders;
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.assessed_by_status == 1 || this.assessed_by_status == 2) {
          return false;
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeOPCRSummaryDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
